export default __webpack_public_path__ + "static/media/icon-clients.3ecc8e9b.svg";